import { ExclamationCircleOutlined } from '@ant-design/icons';

export const ProductNameTip = () => (
  <span className="text-orange-500">
    <ExclamationCircleOutlined className="mr-1" />
    产品名称会影响生成质量，建议准确填写产品名称
  </span>
);
